import React from 'react'
import KeywordClusteringForm from './KeywordClusteringForm'
import SetTitle from '../../utils/set_title'
import Header from '../../components/Headers/Header'

export default function KeywordClustering() {
  SetTitle('Keyword Clustering')
  const description =
    'Una volta selezionata la fonte dato su BigQuery e settati i parametri desiderati, ottiene le main keyword basandosi sulle SERP delle keyword. Per "main keyword" si intende la keyword con il volume massimo all\'interno di un cluster. Un cluster viene creato mettendo insieme le keyword con SERP simili.'

  return (
    <Header
      iconClass="ni ni-atom text-white"
      title="Keyword Clustering"
      description={description}
    >
      <KeywordClusteringForm />
    </Header>
  )
}